import React, { ReactElement } from "react";
import oc from "open-color";
import t from "../helpers/i18n";

export default function DataRelevanceIndication({
  lastUpdate,
}: {
  lastUpdate?: Date;
}): ReactElement {
  let lastUpdateString = "";
  if (lastUpdate !== undefined) {
    const year = lastUpdate.getFullYear();
    const month = String(lastUpdate.getMonth() + 1).padStart(2, "0");
    const day = String(lastUpdate.getDate()).padStart(2, "0");
    const hours = String(lastUpdate.getHours()).padStart(2, "0");
    const minutes = String(lastUpdate.getMinutes()).padStart(2, "0");
    lastUpdateString = `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  return (
    <>
      {lastUpdate === undefined ? (
        <div style={{ fontSize: "11px", color: oc.gray[5] }}>
          {t("No data", "Немає даних", "Нет данных", "Brak danych")}
        </div>
      ) : lastUpdate.getTime() > Date.now() - 60000 ? (
        <div style={{ fontSize: "11px", color: oc.gray[5] }}>
          {t(
            `Recent data (from ${lastUpdateString}).`,
            `Дані актуальні (вiд ${lastUpdateString}).`,
            `Данные актуальны (от ${lastUpdateString}).`,
            `dane są aktualne (od ${lastUpdateString})`,
          )}
        </div>
      ) : (
        <div style={{ fontSize: "11px", color: oc.orange[7] }}>
          {t(
            `Outdated data (from ${lastUpdateString}).`,
            `Дані не актуальні (вiд ${lastUpdateString}).`,
            `Данные неактуальны (от ${lastUpdateString}).`,
            `dane są nieaktualne (od ${lastUpdateString})`,
          )}
        </div>
      )}
    </>
  );
}
